import MonthlySalaryCalculator from "./czechia/MonthlySalaryCalculator";

function App() {
  return (
    <MonthlySalaryCalculator/>
  )
}

export default App
